import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut,
} from "firebase/auth";
import {
  query,
  getDocs,
  getDoc,
  collection,
  doc,
  where,
  addDoc,
} from "firebase/firestore/lite";

import { getAnalytics } from "firebase/analytics";
import { app, auth, db } from "./firebaseConfig";
import { recordLegalAcceptance, upsertUserProfile } from './userProfile';
import { pendingEmailProfileKey } from './authVerification';

const googleProvider = new GoogleAuthProvider();


// Initialize Firebase
const analytics = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true' ? null : getAnalytics(app);

async function getFBStuff() {
  const journey = collection(db, '/firsthome');
  const jSnapshot = await getDocs(journey);
  const fbList = jSnapshot.docs;
   jSnapshot.docs.map(doc => ({ data: doc.data(), id: doc.id, }));
  console.log('dummy data', fbList);
  return fbList;
}




const signInWithGoogle = async (options = {}) => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const profileSnapshot = await getDoc(doc(db, 'users', user.uid));
    if (!profileSnapshot.exists()) {
      if (options.recordLegalAcceptance) {
        await recordLegalAcceptance(user, {
          name: options.name || user.displayName,
          authProvider: 'google',
        });
      } else {
        await upsertUserProfile(user, {
          authProvider: "google",
          name: user.displayName,
        });
      }
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email.trim(), password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const registerWithEmailAndPassword = async (name, email, password) => {
  const trimmedEmail = email.trim();
  const res = await createUserWithEmailAndPassword(auth, trimmedEmail, password);
  const user = res.user;
  await sendEmailVerification(user);
  window.sessionStorage?.setItem(
    pendingEmailProfileKey(user.uid),
    JSON.stringify({ name, email: trimmedEmail, authProvider: 'local' }),
  );
  return user;
};
const logout = () => {
  signOut(auth);
};


// create a new document entry in the breakfast set
// test this by doing a forced reload
const addStep = async () => {
var datetime=new Date();

  await addDoc(collection(db, "/events"), {
    action: 'Test',
    event_time:  new Date(),
    param:'test param'
  });

};

const getBreakfast = async () => {

  const journey = collection(db, '/options');

  console.log('try query(collection)');
  const res= [];
  try {
    //const q = query(collection(db, "/options"), where('Title', '==', 'Breakfast: Get Eggs'));
    const q = query(collection(db, "/options"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      res.push ({id: doc.id, data: doc.data() });
      console.log(doc.id, " => ", doc.data());
   querySnapshot.docs.map(doc => ({ data: doc.data(), id: doc.id, }));

   const updatedGroceryItems = 
   querySnapshot.docs.map(docSnapshot => docSnapshot.data());

  console.log('dumyy data', querySnapshot);
    });
    return res;

  } catch (err) {
    console.log(err);
  }

  // console.log('try getDocs()');

  // const jSnapshot = await getDocs(journey);


};

const getBreakfastStart = async () => {
  const journey = collection(db, '/options');
  console.log('get breakfast start query ');
  try {
    const singleItem = doc(db, 'options', '1ai4cUNafsZJsObUPr6o');
    const docSnapshot = await getDoc(singleItem);

    if (!docSnapshot.exists()) {
      console.log('No such document!');
    } else {
      console.log('Document data:', docSnapshot.data());
    }


    console.log('get breakfast start query ');
    const breakfastQuery = query(journey, where('Title', '==', 'Breakfast: Get Eggs'));
    const jSnapshot = await getDocs(breakfastQuery);
  
    if (jSnapshot.empty) {
      console.log('No matching breakfast documents.');
      return;
    }
    //const jSnapshot = await getDocs(journey);
    const fbList = jSnapshot.docs.map(doc => ({ data: doc.data(), id: doc.id, }));
    console.log('dummy data', fbList);
    return fbList;
  

  } catch (err) {
    console.log(err);
  }


};

// 

//getBreakfast();

export {
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  logout,
  getBreakfast,
  getFBStuff,
  addStep
};


if (
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname)
) {
  window.getToken = async () => {
    const user = auth.currentUser;

    if (!user) {
      throw new Error('Sign in first, then run: await getToken()');
    }

    return user.getIdToken(true);
  };
}
